'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = require('react-redux');

var _components = require('components');

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _DeleteAppPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/account/DeleteAppPopup');

var _DeleteAppPopup2 = _interopRequireDefault(_DeleteAppPopup);

var _AppSideEffects = require('../AppSideEffects/AppSideEffects');

var _AppSideEffects2 = _interopRequireDefault(_AppSideEffects);

var _subscriptions = require('redux/modules/subscriptions');

var subscriptionService = _interopRequireWildcard(_subscriptions);

var _applications = require('redux/modules/applications');

var _utils = require('utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeleteAppPopup = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loading: state.applications.applications.loading,
    loaded: state.applications.applications.loaded,
    loadingError: state.applications.applications.loadingError,
    applications: state.applications.applications.applications,

    creating: state.applications.application.creating,
    created: state.applications.application.created,

    deleting: state.applications.application.deleting,
    deleted: state.applications.application.deleted
  };
}), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(DeleteAppPopup, _React$Component);

  function DeleteAppPopup(props) {
    (0, _classCallCheck3.default)(this, DeleteAppPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DeleteAppPopup.__proto__ || (0, _getPrototypeOf2.default)(DeleteAppPopup)).call(this, props));

    _this.onDelete = _this.onDelete.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(DeleteAppPopup, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.deleting && nextProps.deleted) {
        this.props.onCloseYes();
      }
    }
  }, {
    key: 'onDelete',
    value: function onDelete() {
      var _props = this.props,
          dispatch = _props.dispatch,
          appId = _props.appId;

      dispatch((0, _applications.deleteApplication)(appId));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          appId = _props2.appId,
          appName = _props2.appName,
          deleting = _props2.deleting;


      return _react2.default.createElement(
        _AppSideEffects2.default,
        null,
        _react2.default.createElement(_DeleteAppPopup2.default, {
          icon: '/megascans_logo_small.png',
          title: 'Delete App',
          appName: appName,
          onDeleteClick: this.onDelete,
          learnMore: 'https://quixel.github.io/megascans-api-docs/quick-start-guide/',
          deleting: deleting
        })
      );
    }
  }]);
  return DeleteAppPopup;
}(_react2.default.Component)) || _class);
exports.default = DeleteAppPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DeleteAppPopup/DeleteAppPopup.jsx
// module id = 2790
// module chunks = 0